const state = {
  values: [],
  rangeDevicesValuesMonth: {
    from: null,
    to: null
  },
  sendValuesBody: {},
  devicesCanSend: [],
  displayDevices: [],
  isLoading: true
};

export default state;
